import { useTranslation } from "react-i18next";
import logo from "../assets/logo/newlogo/logo7.png";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import { BsArrowUp, BsGeoAlt, BsWhatsapp } from "react-icons/bs";
import React, { useState } from "react";

const Footer = () => {
  const { t } = useTranslation();
  const [result, setResult] = useState("");
  const [phone, setPhone] = useState("");

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setResult("Sending....");

    const formData = new FormData();
    formData.append("access_key", "54c3282c-b58b-4ce5-b923-093af66e3101");
    formData.append("phone", phone);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully");
        setPhone("");
      } else {
        setResult(data.message || "Error submitting form");
      }
    } catch (error) {
      console.error("Error:", error);
      setResult("Error submitting form");
    }
  };

  return (
    <section
      id="contact"
      className="flex flex-col p-5 bg-black/80 items-center justify-center text-white relative"
    >
      <div className="flex flex-col md:flex-row justify-between w-full p-7">
        <div className="flex flex-col py-7 items-center justify-center ">
          <div className="py-2">
            <h1 className="text-6xl md:text-8xl font-primary">
              {t("footer.greeting")}
            </h1>
          </div>
          <div className="py-2">
            <img className="w-[200px]" src={logo} alt="logo" />
          </div>
        </div>

        <div className="flex flex-col items-center justify-center ">
          <div className="flex items-center space-x-8">
            <div className="flex flex-col items-center text-3xl space-y-6 ">
              <div>
                <h2>{t("footer.contact.title")}</h2>
                <h3 className="text-[15px]">{t("footer.contact.subtitle")}</h3>
                <form onSubmit={onSubmit} className="relative mt-2">
                  <input
                    type="tel"
                    name="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder={t("footer.contact.placeholder")}
                    autoComplete="phone"
                    aria-label={t("footer.contact.ariaLabel")}
                    className="block w-full rounded-2xl border border-neutral-300 bg-transparent py-4 pl-6 pr-20 text-base text-neutral-950 ring-4 ring-transparent transition placeholder:text-neutral-500 focus:border-neutral-950 focus:outline-none focus:ring-neutral-950/5"
                    required
                  />

                  <div className="absolute inset-y-1 right-1 flex justify-end">
                    <button
                      type="submit"
                      aria-label={t("footer.contact.submitAria")}
                      className="flex aspect-square h-full items-center justify-center rounded-xl bg-neutral-950 text-white transition hover:bg-neutral-800"
                    >
                      <svg
                        viewBox="0 0 16 6"
                        aria-hidden="true"
                        className="w-4"
                      >
                        <path
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16 3 10 .5v2H0v1h10v2L16 3Z"
                        />
                      </svg>
                    </button>
                  </div>
                </form>
                {result && <p className="mt-2 text-sm text-white">{result}</p>}
              </div>

              <div className="flex items-center space-x-4">
                <BsGeoAlt className="text-5xl text-amber-300" />
                <div className="flex flex-col text-xl">
                  <span>{t("footer.address.title")}</span>
                  <span>{t("footer.address.line1")}</span>
                  <span>{t("footer.address.line2")}</span>
                  <a
                    href="tel:+917200945514"
                    className="text-white-800 hover:underline"
                  >
                    {t("footer.address.phone")}
                  </a>
                  <a
                    href="mailto:info@spotcard.in"
                    className="text-white-800 hover:underline"
                  >
                    {t("footer.address.email")}
                  </a>
                  <a
                    href="https://wa.me/917200945514"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 text-green-500 hover:underline mt-2"
                  >
                    <BsWhatsapp className="text-2xl" />
                    <span>{t("footer.address.whatsapp")}</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex items-start justify-center">
              <BsArrowUp
                className="text-sm sm:text-6xl md:text-9xl cursor-pointer arrow-hover"
                onClick={handleScrollToTop}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between p-4 text-white">
        <p className="pr-7">{t("footer.copyright")}</p>
        <div className="flex space-x-4 ">
          <a
            href="https://www.facebook.com/profile.php?id=61576602617463"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Facebook page"
          >
            <FaFacebook className="text-xl hover:text-blue-500 transition duration-300" />
          </a>

          <a
            href="https://www.twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Twitter profile"
          >
            <FaTwitter className="text-xl hover:text-blue-400 transition duration-300" />
          </a>

          <a
            href="https://www.instagram.com/spotcard.in/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Instagram page"
          >
            <FaInstagram className="text-xl hover:text-pink-500 transition duration-300" />
          </a>

          <a
            href="https://www.linkedin.com/company/spotcard-business-solution/?viewAsMember=true"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our LinkedIn profile"
          >
            <FaLinkedin className="text-xl hover:text-blue-700 transition duration-300" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Footer;
